import {assert} from "@prosay/common"
import {getLogger} from "@prosay/logging"
import {atob} from "./base64"

const logger = getLogger(__filename)

export const dataURIToBlob = logger.debug((dataURI: string) => {
    // TODO: Look at the case where atob/Blob is not supported on react native
    const binary = [...atob(dataURI.split(",")[1])]
    const array = binary.map(c => c.charCodeAt(0))
    // eslint-disable-next-line no-undef
    return new Blob([new Uint8Array(array)])
}, "dataURIToBlob")

// TODO: Make sure FileReader is supported on react native
export const blobToDataURL = logger.debug(
    async (blob: Blob) =>
        await new Promise<string>(resolve => {
            // eslint-disable-next-line no-undef
            const reader = new FileReader()
            reader.onload = ({target}) => {
                assert(typeof target?.result === "string")
                resolve(target.result)
            }
            reader.readAsDataURL(blob)
        }),
    "blobToDataURL",
)
